import ActivityInput from "@/pages/(app)/returns/view/components/return-activity/activity-input";
import ActivityList from "@/pages/(app)/returns/view/components/return-activity/activity-list";
import type { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Label } from "@babackapp/ui/components/label";
import { ActivityDeactivateAutoTreatLogistician } from "@/pages/(app)/returns/view/components/return-activity/activity-deactivate-auto-treat-logistician.tsx";
import { useEffect, useRef } from "react";

type ReturnRequestActivityProps = {
  returnRequest: ReturnRequestDto;
  markAsRead: () => void;
};

export default function Activity({
  returnRequest,
  markAsRead,
}: ReturnRequestActivityProps) {
  const t = useTranslation();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    // Observe the activity list specifically, not the wrapper that includes the
    // input — otherwise scrolling just the input into view would mark notes as read.
    const target =
      ref.current.querySelector<HTMLElement>("#return-request-activities") ??
      ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) markAsRead();
      },
      { threshold: 0.1 },
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [markAsRead]);

  return (
    <div className="mt-6" ref={ref}>
      <div className="flex items-center justify-between mb-4">
        <Label className="flex-1">{t("returnDetail.activity")}</Label>
        <ActivityDeactivateAutoTreatLogistician returnRequest={returnRequest} />
      </div>
      <div className={"mt-2 flex flex-col gap-2"}>
        <ActivityInput
          returnRequestId={returnRequest.id}
          shopId={returnRequest.shopId}
        />
        <ActivityList
          activities={returnRequest.logs}
          returnRequestId={returnRequest.id}
        />
      </div>
    </div>
  );
}
